/* tslint:disable */
/* eslint-disable */
/**
 * NORA Api
 *  ## Headers  ### X-App-Version  Remember to include the `X-App-Version` header in every request. This will verify that the app version works with this API version. The API will return a `X-Minimum-App-Version` header as well including the minimum app version that is supported by this API. The contents of the header are is a JSON encoded DTO, `VersionHeaderDTO`. 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiResult } from '../models';
// @ts-ignore
import type { DeleteSymbol200Response } from '../models';
// @ts-ignore
import type { DeleteSymbolPack200Response } from '../models';
// @ts-ignore
import type { DownloadSymbolContentDispositionParameter } from '../models';
// @ts-ignore
import type { GetSymbolPack200Response } from '../models';
// @ts-ignore
import type { ListSymbolPacks200Response } from '../models';
// @ts-ignore
import type { ListSymbolPacksUsageParameter } from '../models';
// @ts-ignore
import type { ListSymbols200Response } from '../models';
// @ts-ignore
import type { SymbolPackUpdateDTO } from '../models';
// @ts-ignore
import type { SymbolUpdateDTO } from '../models';
// @ts-ignore
import type { UpdateSymbol200Response } from '../models';
/**
 * SymbolsApi - axios parameter creator
 */
export const SymbolsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary addSymbolToPack
         * @param {string} packId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSymbolToPack: async (packId: string, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'packId' is not null or undefined
            assertParamExists('addSymbolToPack', 'packId', packId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('addSymbolToPack', 'file', file)
            const localVarPath = `/api/nora/symbol/pack/{packId}/symbol`
                .replace('{packId}', encodeURIComponent(String(packId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deleteSymbol
         * @param {string} packId 
         * @param {string} symbolId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSymbol: async (packId: string, symbolId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'packId' is not null or undefined
            assertParamExists('deleteSymbol', 'packId', packId)
            // verify required parameter 'symbolId' is not null or undefined
            assertParamExists('deleteSymbol', 'symbolId', symbolId)
            const localVarPath = `/api/nora/symbol/pack/{packId}/symbol/{symbolId}`
                .replace('{packId}', encodeURIComponent(String(packId)))
                .replace('{symbolId}', encodeURIComponent(String(symbolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deleteSymbolPack
         * @param {string} packId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSymbolPack: async (packId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'packId' is not null or undefined
            assertParamExists('deleteSymbolPack', 'packId', packId)
            const localVarPath = `/api/nora/symbol/pack/{packId}`
                .replace('{packId}', encodeURIComponent(String(packId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} packId 
         * @param {string} symbolId 
         * @param {DownloadSymbolContentDispositionParameter} [contentDisposition] 
         * @param {string} [color] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSymbol: async (packId: string, symbolId: string, contentDisposition?: DownloadSymbolContentDispositionParameter, color?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'packId' is not null or undefined
            assertParamExists('downloadSymbol', 'packId', packId)
            // verify required parameter 'symbolId' is not null or undefined
            assertParamExists('downloadSymbol', 'symbolId', symbolId)
            const localVarPath = `/api/nora/symbol/pack/{packId}/symbol/{symbolId}/download`
                .replace('{packId}', encodeURIComponent(String(packId)))
                .replace('{symbolId}', encodeURIComponent(String(symbolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            if (contentDisposition !== undefined) {
                localVarQueryParameter['contentDisposition'] = contentDisposition;
            }

            if (color !== undefined) {
                localVarQueryParameter['color'] = color;
            }

            localVarHeaderParameter['Accept'] = 'image/png,image/svg+xml,application/octet-stream,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getSymbol
         * @param {string} packId 
         * @param {string} symbolId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSymbol: async (packId: string, symbolId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'packId' is not null or undefined
            assertParamExists('getSymbol', 'packId', packId)
            // verify required parameter 'symbolId' is not null or undefined
            assertParamExists('getSymbol', 'symbolId', symbolId)
            const localVarPath = `/api/nora/symbol/pack/{packId}/symbol/{symbolId}`
                .replace('{packId}', encodeURIComponent(String(packId)))
                .replace('{symbolId}', encodeURIComponent(String(symbolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getSymbolPack
         * @param {string} packId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSymbolPack: async (packId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'packId' is not null or undefined
            assertParamExists('getSymbolPack', 'packId', packId)
            const localVarPath = `/api/nora/symbol/pack/{packId}`
                .replace('{packId}', encodeURIComponent(String(packId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary listSymbolPacks
         * @param {ListSymbolPacksUsageParameter} [usage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSymbolPacks: async (usage?: ListSymbolPacksUsageParameter, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nora/symbol/pack`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            if (usage !== undefined) {
                localVarQueryParameter['usage'] = usage;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary listSymbols
         * @param {ListSymbolPacksUsageParameter} [usage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSymbols: async (usage?: ListSymbolPacksUsageParameter, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nora/symbol/symbol`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            if (usage !== undefined) {
                localVarQueryParameter['usage'] = usage;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateSymbol
         * @param {string} packId 
         * @param {string} symbolId 
         * @param {SymbolUpdateDTO} symbolUpdateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSymbol: async (packId: string, symbolId: string, symbolUpdateDTO: SymbolUpdateDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'packId' is not null or undefined
            assertParamExists('updateSymbol', 'packId', packId)
            // verify required parameter 'symbolId' is not null or undefined
            assertParamExists('updateSymbol', 'symbolId', symbolId)
            // verify required parameter 'symbolUpdateDTO' is not null or undefined
            assertParamExists('updateSymbol', 'symbolUpdateDTO', symbolUpdateDTO)
            const localVarPath = `/api/nora/symbol/pack/{packId}/symbol/{symbolId}`
                .replace('{packId}', encodeURIComponent(String(packId)))
                .replace('{symbolId}', encodeURIComponent(String(symbolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(symbolUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateSymbolPack
         * @param {string} packId 
         * @param {SymbolPackUpdateDTO} symbolPackUpdateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSymbolPack: async (packId: string, symbolPackUpdateDTO: SymbolPackUpdateDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'packId' is not null or undefined
            assertParamExists('updateSymbolPack', 'packId', packId)
            // verify required parameter 'symbolPackUpdateDTO' is not null or undefined
            assertParamExists('updateSymbolPack', 'symbolPackUpdateDTO', symbolPackUpdateDTO)
            const localVarPath = `/api/nora/symbol/pack/{packId}`
                .replace('{packId}', encodeURIComponent(String(packId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(symbolPackUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} overwrite 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadSymbolPack: async (overwrite: boolean, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'overwrite' is not null or undefined
            assertParamExists('uploadSymbolPack', 'overwrite', overwrite)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadSymbolPack', 'file', file)
            const localVarPath = `/api/nora/symbol/pack/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            if (overwrite !== undefined) {
                localVarQueryParameter['overwrite'] = overwrite;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SymbolsApi - functional programming interface
 */
export const SymbolsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SymbolsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary addSymbolToPack
         * @param {string} packId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addSymbolToPack(packId: string, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateSymbol200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addSymbolToPack(packId, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SymbolsApi.addSymbolToPack']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary deleteSymbol
         * @param {string} packId 
         * @param {string} symbolId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSymbol(packId: string, symbolId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteSymbol200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSymbol(packId, symbolId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SymbolsApi.deleteSymbol']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary deleteSymbolPack
         * @param {string} packId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSymbolPack(packId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteSymbolPack200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSymbolPack(packId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SymbolsApi.deleteSymbolPack']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} packId 
         * @param {string} symbolId 
         * @param {DownloadSymbolContentDispositionParameter} [contentDisposition] 
         * @param {string} [color] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadSymbol(packId: string, symbolId: string, contentDisposition?: DownloadSymbolContentDispositionParameter, color?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadSymbol(packId, symbolId, contentDisposition, color, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SymbolsApi.downloadSymbol']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary getSymbol
         * @param {string} packId 
         * @param {string} symbolId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSymbol(packId: string, symbolId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSymbolPack200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSymbol(packId, symbolId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SymbolsApi.getSymbol']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary getSymbolPack
         * @param {string} packId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSymbolPack(packId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSymbolPack200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSymbolPack(packId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SymbolsApi.getSymbolPack']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary listSymbolPacks
         * @param {ListSymbolPacksUsageParameter} [usage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSymbolPacks(usage?: ListSymbolPacksUsageParameter, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListSymbolPacks200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSymbolPacks(usage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SymbolsApi.listSymbolPacks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary listSymbols
         * @param {ListSymbolPacksUsageParameter} [usage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSymbols(usage?: ListSymbolPacksUsageParameter, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListSymbols200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSymbols(usage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SymbolsApi.listSymbols']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary updateSymbol
         * @param {string} packId 
         * @param {string} symbolId 
         * @param {SymbolUpdateDTO} symbolUpdateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSymbol(packId: string, symbolId: string, symbolUpdateDTO: SymbolUpdateDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateSymbol200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSymbol(packId, symbolId, symbolUpdateDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SymbolsApi.updateSymbol']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary updateSymbolPack
         * @param {string} packId 
         * @param {SymbolPackUpdateDTO} symbolPackUpdateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSymbolPack(packId: string, symbolPackUpdateDTO: SymbolPackUpdateDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSymbolPack200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSymbolPack(packId, symbolPackUpdateDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SymbolsApi.updateSymbolPack']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {boolean} overwrite 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadSymbolPack(overwrite: boolean, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSymbolPack200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadSymbolPack(overwrite, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SymbolsApi.uploadSymbolPack']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SymbolsApi - factory interface
 */
export const SymbolsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SymbolsApiFp(configuration)
    return {
        /**
         * 
         * @summary addSymbolToPack
         * @param {SymbolsApiAddSymbolToPackRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSymbolToPack(requestParameters: SymbolsApiAddSymbolToPackRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateSymbol200Response> {
            return localVarFp.addSymbolToPack(requestParameters.packId, requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deleteSymbol
         * @param {SymbolsApiDeleteSymbolRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSymbol(requestParameters: SymbolsApiDeleteSymbolRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteSymbol200Response> {
            return localVarFp.deleteSymbol(requestParameters.packId, requestParameters.symbolId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deleteSymbolPack
         * @param {SymbolsApiDeleteSymbolPackRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSymbolPack(requestParameters: SymbolsApiDeleteSymbolPackRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteSymbolPack200Response> {
            return localVarFp.deleteSymbolPack(requestParameters.packId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SymbolsApiDownloadSymbolRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSymbol(requestParameters: SymbolsApiDownloadSymbolRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadSymbol(requestParameters.packId, requestParameters.symbolId, requestParameters.contentDisposition, requestParameters.color, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getSymbol
         * @param {SymbolsApiGetSymbolRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSymbol(requestParameters: SymbolsApiGetSymbolRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetSymbolPack200Response> {
            return localVarFp.getSymbol(requestParameters.packId, requestParameters.symbolId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getSymbolPack
         * @param {SymbolsApiGetSymbolPackRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSymbolPack(requestParameters: SymbolsApiGetSymbolPackRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetSymbolPack200Response> {
            return localVarFp.getSymbolPack(requestParameters.packId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary listSymbolPacks
         * @param {SymbolsApiListSymbolPacksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSymbolPacks(requestParameters: SymbolsApiListSymbolPacksRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListSymbolPacks200Response> {
            return localVarFp.listSymbolPacks(requestParameters.usage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary listSymbols
         * @param {SymbolsApiListSymbolsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSymbols(requestParameters: SymbolsApiListSymbolsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListSymbols200Response> {
            return localVarFp.listSymbols(requestParameters.usage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateSymbol
         * @param {SymbolsApiUpdateSymbolRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSymbol(requestParameters: SymbolsApiUpdateSymbolRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateSymbol200Response> {
            return localVarFp.updateSymbol(requestParameters.packId, requestParameters.symbolId, requestParameters.symbolUpdateDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateSymbolPack
         * @param {SymbolsApiUpdateSymbolPackRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSymbolPack(requestParameters: SymbolsApiUpdateSymbolPackRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetSymbolPack200Response> {
            return localVarFp.updateSymbolPack(requestParameters.packId, requestParameters.symbolPackUpdateDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SymbolsApiUploadSymbolPackRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadSymbolPack(requestParameters: SymbolsApiUploadSymbolPackRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetSymbolPack200Response> {
            return localVarFp.uploadSymbolPack(requestParameters.overwrite, requestParameters.file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addSymbolToPack operation in SymbolsApi.
 */
export interface SymbolsApiAddSymbolToPackRequest {
    readonly packId: string

    readonly file: File
}

/**
 * Request parameters for deleteSymbol operation in SymbolsApi.
 */
export interface SymbolsApiDeleteSymbolRequest {
    readonly packId: string

    readonly symbolId: string
}

/**
 * Request parameters for deleteSymbolPack operation in SymbolsApi.
 */
export interface SymbolsApiDeleteSymbolPackRequest {
    readonly packId: string
}

/**
 * Request parameters for downloadSymbol operation in SymbolsApi.
 */
export interface SymbolsApiDownloadSymbolRequest {
    readonly packId: string

    readonly symbolId: string

    readonly contentDisposition?: DownloadSymbolContentDispositionParameter

    readonly color?: string
}

/**
 * Request parameters for getSymbol operation in SymbolsApi.
 */
export interface SymbolsApiGetSymbolRequest {
    readonly packId: string

    readonly symbolId: string
}

/**
 * Request parameters for getSymbolPack operation in SymbolsApi.
 */
export interface SymbolsApiGetSymbolPackRequest {
    readonly packId: string
}

/**
 * Request parameters for listSymbolPacks operation in SymbolsApi.
 */
export interface SymbolsApiListSymbolPacksRequest {
    readonly usage?: ListSymbolPacksUsageParameter
}

/**
 * Request parameters for listSymbols operation in SymbolsApi.
 */
export interface SymbolsApiListSymbolsRequest {
    readonly usage?: ListSymbolPacksUsageParameter
}

/**
 * Request parameters for updateSymbol operation in SymbolsApi.
 */
export interface SymbolsApiUpdateSymbolRequest {
    readonly packId: string

    readonly symbolId: string

    readonly symbolUpdateDTO: SymbolUpdateDTO
}

/**
 * Request parameters for updateSymbolPack operation in SymbolsApi.
 */
export interface SymbolsApiUpdateSymbolPackRequest {
    readonly packId: string

    readonly symbolPackUpdateDTO: SymbolPackUpdateDTO
}

/**
 * Request parameters for uploadSymbolPack operation in SymbolsApi.
 */
export interface SymbolsApiUploadSymbolPackRequest {
    readonly overwrite: boolean

    readonly file: File
}

/**
 * SymbolsApi - object-oriented interface
 */
export class SymbolsApi extends BaseAPI {
    /**
     * 
     * @summary addSymbolToPack
     * @param {SymbolsApiAddSymbolToPackRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addSymbolToPack(requestParameters: SymbolsApiAddSymbolToPackRequest, options?: RawAxiosRequestConfig) {
        return SymbolsApiFp(this.configuration).addSymbolToPack(requestParameters.packId, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deleteSymbol
     * @param {SymbolsApiDeleteSymbolRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteSymbol(requestParameters: SymbolsApiDeleteSymbolRequest, options?: RawAxiosRequestConfig) {
        return SymbolsApiFp(this.configuration).deleteSymbol(requestParameters.packId, requestParameters.symbolId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deleteSymbolPack
     * @param {SymbolsApiDeleteSymbolPackRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteSymbolPack(requestParameters: SymbolsApiDeleteSymbolPackRequest, options?: RawAxiosRequestConfig) {
        return SymbolsApiFp(this.configuration).deleteSymbolPack(requestParameters.packId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SymbolsApiDownloadSymbolRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadSymbol(requestParameters: SymbolsApiDownloadSymbolRequest, options?: RawAxiosRequestConfig) {
        return SymbolsApiFp(this.configuration).downloadSymbol(requestParameters.packId, requestParameters.symbolId, requestParameters.contentDisposition, requestParameters.color, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getSymbol
     * @param {SymbolsApiGetSymbolRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSymbol(requestParameters: SymbolsApiGetSymbolRequest, options?: RawAxiosRequestConfig) {
        return SymbolsApiFp(this.configuration).getSymbol(requestParameters.packId, requestParameters.symbolId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getSymbolPack
     * @param {SymbolsApiGetSymbolPackRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSymbolPack(requestParameters: SymbolsApiGetSymbolPackRequest, options?: RawAxiosRequestConfig) {
        return SymbolsApiFp(this.configuration).getSymbolPack(requestParameters.packId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary listSymbolPacks
     * @param {SymbolsApiListSymbolPacksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listSymbolPacks(requestParameters: SymbolsApiListSymbolPacksRequest = {}, options?: RawAxiosRequestConfig) {
        return SymbolsApiFp(this.configuration).listSymbolPacks(requestParameters.usage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary listSymbols
     * @param {SymbolsApiListSymbolsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listSymbols(requestParameters: SymbolsApiListSymbolsRequest = {}, options?: RawAxiosRequestConfig) {
        return SymbolsApiFp(this.configuration).listSymbols(requestParameters.usage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateSymbol
     * @param {SymbolsApiUpdateSymbolRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateSymbol(requestParameters: SymbolsApiUpdateSymbolRequest, options?: RawAxiosRequestConfig) {
        return SymbolsApiFp(this.configuration).updateSymbol(requestParameters.packId, requestParameters.symbolId, requestParameters.symbolUpdateDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateSymbolPack
     * @param {SymbolsApiUpdateSymbolPackRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateSymbolPack(requestParameters: SymbolsApiUpdateSymbolPackRequest, options?: RawAxiosRequestConfig) {
        return SymbolsApiFp(this.configuration).updateSymbolPack(requestParameters.packId, requestParameters.symbolPackUpdateDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SymbolsApiUploadSymbolPackRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadSymbolPack(requestParameters: SymbolsApiUploadSymbolPackRequest, options?: RawAxiosRequestConfig) {
        return SymbolsApiFp(this.configuration).uploadSymbolPack(requestParameters.overwrite, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }
}

